<template>
  <div
    class="self-first"
    :style="{
      backgroundImage: 'url(' + dataInfo.cover + ')'
    }"
  >
    <div class="g-box">
      <div class="title">
        <div class="en">{{ dataInfo.tips }}</div>
        <div class="tt">{{ dataInfo.name }}</div>
      </div>
      <div class="content">
        <div class="swiper-container" id="swiper12">
          <div class="swiper-wrapper">
            <div
              class="items swiper-slide"
              v-for="(el, i) in dataList"
              :key="i"
            >
              <div
                v-for="item in el"
                :key="item.id"
                :style="{
                  backgroundImage: 'url(' + item.image + ')'
                }"
                class="item"
                @click="toDetail(item)"
              >
                <div class="no">{{ item.title }}</div>
                <div class="tit">{{ item.subtitle }}</div>
                <div class="intro">{{ item.tips }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bot">
      <div class="line"></div>
      <div class="btns">
        <div class="btn btn-le swiper-button-prev"></div>
        <div class="btn btn-ri swiper-button-next"></div>
      </div>
    </div>
  </div>
</template>

<script>
import pageMain_mx from "../../../mixins/pageMain_mx";
import Swiper from "swiper/swiper-bundle";

export default {
  mixins: [pageMain_mx],
  data() {
    return {
      dataInfo: {},
      dataList: []
    };
  },
  props: {
    menuId: {
      type: String,
      default: ""
    },
    pageType: {
      type: String,
      default: ""
    }
  },
  components: {},
  async mounted() {
    const dataInfo = await this.getMenuInfo(this.menuId);
    const data = await this.getMenuList({
      pageNum: 1,
      pageSize: 999,
      menuId: this.menuId
    });
    const arr = [];
    for (let i = 0; i < data.length; i += 3) {
      arr.push(data.slice(i, i + 3));
    }
    this.dataList = arr;
    console.log(arr, "arr");
    this.$nextTick(() => {
      this.UserSwiper();
    });
    this.dataInfo = dataInfo;

    // this.dataList = data;
  },
  methods: {
    UserSwiper() {
      new Swiper("#swiper12", {
        loop: true,
        autoplay: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      });
    },
    toDetail(item) {
      this.toUrl(item.url);
    }
  }
};
</script>
<style lang="less">
.self-first {
  padding-left: 65px;
  padding-top: 140px;
  height: 1080px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  box-sizing: border-box;
  .title {
    display: flex;
    align-items: center;
    text-align: center;

    .en {
      font-size: 72px;
      font-family: "en-tit";
      color: #fff;
      text-transform: uppercase;
    }
    .tt {
      padding-left: 36px;
      font-size: 48px;
      font-family: SourceHanSansCN-Heavy, SourceHanSansCN;
      font-weight: 800;
      color: #fff;
    }
  }
  .items {
    margin-top: 70px;
    display: flex;
    .item {
      margin-right: 30px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      text-align: center;
      width: 380px;
      height: 380px;
      border-radius: 50%;
      cursor: pointer;
      .no {
        font-size: 36px;
        font-weight: 600;
        color: #fff;
        line-height: 50px;
      }
      .tit {
        font-size: 36px;
        font-weight: 600;
        color: #fff;
        line-height: 50px;
      }
      .intro {
        padding-top: 15px;
        width: 230px;
        font-size: 14px;
        color: #fff;
      }
    }
  }
  .bot {
    padding-top: 108px;
    display: flex;
    align-items: center;
    .line {
      margin-left: 200px;
      width: 1200px;
      height: 2px;
      background-color: #fff;
    }
    .btns {
      display: flex;
      .btn {
        width: 72px;
        height: 72px;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        cursor: pointer;
      }
      .btn-le {
        margin-left: 40px;
        margin-right: 16px;
        background-image: url("../../../assets/img/icon-le.png");
      }
      .btn-ri {
        background-image: url("../../../assets/img/icon-ri.png");
      }
    }
  }
}
</style>
